import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function InternalServerErrorIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="151"
        viewBox="0 0 168 151"
        width="168"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M81.963 128.5c33.464 0 60.592-27.146 60.592-60.632S115.427 7.237 81.962 7.237c-33.464 0-60.592 27.145-60.592 60.631 0 33.486 27.128 60.632 60.593 60.632Z"
          fill="url(#a)"
        />
        <path
          clipRule="evenodd"
          d="M1.447 38.409c10.619-6.38 22.648-7.596 34.166-7.214a2.983 2.983 0 0 1-.197 5.964c-11.054-.367-21.722.85-30.9 6.365a2.98 2.98 0 0 1-4.09-1.022 2.984 2.984 0 0 1 1.021-4.093Z"
          fill="url(#b)"
          fillRule="evenodd"
        />
        <g filter="url(#c)">
          <ellipse cx="67.5" cy="59" fill="#9DA4AE" rx="36.5" ry="6.5" />
        </g>
        <g filter="url(#d)">
          <ellipse cx="129.5" cy="59" fill="#384250" fillOpacity=".6" rx="16.5" ry="6.5" />
        </g>
        <g filter="url(#e)">
          <ellipse cx="90.5" cy="122" fill="#9DA4AE" rx="36.5" ry="6.5" />
        </g>
        <path
          clipRule="evenodd"
          d="M159.574 86.886a2.984 2.984 0 0 1-1.021 4.093c-10.618 6.38-22.653 7.595-34.17 7.214a2.982 2.982 0 0 1-2.881-3.08 2.981 2.981 0 0 1 3.078-2.884c11.054.366 21.727-.852 30.903-6.365a2.98 2.98 0 0 1 4.091 1.022Z"
          fill="url(#f)"
          fillRule="evenodd"
        />
        <path
          d="M77.702 121.124h30.284c10.154 0 18.387-11.005 18.387-24.584 0-13.578-8.233-24.587-18.387-24.587H77.702c6.283 0 11.828 4.21 15.142 10.655a31.62 31.62 0 0 1 0 27.891c-3.314 6.427-8.86 10.625-15.142 10.625Z"
          fill="url(#g)"
        />
        <path
          d="M99.475 80.98c-3.697-7.173-9.885-11.87-16.892-11.87h-6.768c-11.33 0-20.517 12.283-20.517 27.43 0 15.148 9.188 27.427 20.517 27.431h6.79c7.006 0 13.203-4.688 16.892-11.87a35.29 35.29 0 0 0 0-31.112l-.022-.009Z"
          fill="url(#h)"
        />
        <path
          d="M92.631 80.98c-3.688-7.16-9.864-11.853-16.858-11.87-11.321 0-20.496 12.292-20.496 27.43 0 15.139 9.175 27.414 20.496 27.431 6.994 0 13.17-4.688 16.858-11.87a35.248 35.248 0 0 0 0-31.112v-.009Z"
          fill="url(#i)"
        />
        <path
          d="M78.475 91.483c-1.021 1.797-2.73 2.974-4.666 2.974h-1.87c-3.13 0-5.667-3.077-5.667-6.872s2.538-6.87 5.667-6.872h1.876c1.935 0 3.647 1.175 4.666 2.974a8.171 8.171 0 0 1 .998 3.897 8.17 8.17 0 0 1-.998 3.897l-.006.002Z"
          fill="url(#j)"
        />
        <path
          d="M78.475 109.984c-1.021 1.797-2.73 2.974-4.666 2.974h-1.87c-3.13 0-5.667-3.077-5.667-6.872s2.538-6.87 5.667-6.872h1.876c1.935 0 3.647 1.175 4.666 2.974a8.172 8.172 0 0 1 .998 3.897 8.169 8.169 0 0 1-.998 3.897l-.006.002Z"
          fill="url(#k)"
        />
        <path
          d="M76.386 91.483c-.999 1.794-2.67 2.97-4.564 2.974-3.066 0-5.55-3.08-5.55-6.872 0-3.793 2.484-6.868 5.55-6.872 1.893 0 3.565 1.175 4.564 2.974a8.291 8.291 0 0 1 .98 3.897 8.291 8.291 0 0 1-.98 3.897v.002ZM76.386 109.984c-.999 1.794-2.67 2.97-4.564 2.974-3.066 0-5.55-3.079-5.55-6.872 0-3.792 2.484-6.867 5.55-6.872 1.893 0 3.565 1.175 4.564 2.974a8.29 8.29 0 0 1 .98 3.897 8.29 8.29 0 0 1-.98 3.897v.002Z"
          fill="#6C737F"
        />
        <path
          d="M82.298 60.819H52.014c-10.154 0-18.391-11.005-18.391-24.583 0-13.58 8.237-24.588 18.391-24.588h30.284c-6.283 0-11.828 4.211-15.142 10.655a30.512 30.512 0 0 0-3.246 13.95 30.49 30.49 0 0 0 3.246 13.945c3.314 6.41 8.86 10.62 15.142 10.62Z"
          fill="url(#l)"
        />
        <path
          d="M60.52 20.692c3.702-7.173 9.89-11.87 16.897-11.87h6.79c11.329 0 20.516 12.283 20.516 27.43 0 15.148-9.187 27.426-20.517 27.43h-6.789c-7.007 0-13.204-4.687-16.897-11.869a34.114 34.114 0 0 1-3.616-15.56 34.114 34.114 0 0 1 3.616-15.561Z"
          fill="url(#m)"
        />
        <path
          d="M67.365 20.692c3.693-7.16 9.864-11.853 16.862-11.87 11.321 0 20.496 12.292 20.496 27.43 0 15.14-9.175 27.414-20.496 27.426-6.998 0-13.17-4.688-16.862-11.865a34.114 34.114 0 0 1-3.616-15.56 34.114 34.114 0 0 1 3.616-15.561Z"
          fill="url(#n)"
        />
        <path
          d="M85.99 31.556c2.214 0 4.009-2.492 4.009-5.566s-1.795-5.566-4.008-5.566c-2.214 0-4.008 2.492-4.008 5.566s1.794 5.566 4.008 5.566Z"
          fill="url(#o)"
        />
        <path
          d="M86.082 32.61c2.772 0 5.019-2.959 5.019-6.608 0-3.65-2.247-6.607-5.019-6.607-2.771 0-5.018 2.958-5.018 6.607 0 3.65 2.247 6.608 5.018 6.608ZM86.082 53.754c2.772 0 5.019-2.958 5.019-6.608 0-3.649-2.247-6.607-5.019-6.607-2.771 0-5.018 2.958-5.018 6.607 0 3.65 2.247 6.608 5.018 6.608Z"
          fill="#6C737F"
        />
        <path
          d="M25.136 77.222c.472-1.957 3.256-1.957 3.728 0 .169.7.715 1.245 1.414 1.414 1.957.472 1.957 3.256 0 3.728-.7.169-1.245.715-1.414 1.414-.472 1.957-3.256 1.957-3.728 0a1.918 1.918 0 0 0-1.414-1.414c-1.957-.472-1.957-3.256 0-3.728a1.918 1.918 0 0 0 1.414-1.414Z"
          fill="url(#p)"
        />
        <path
          d="M85.99 31.556c2.214 0 4.009-2.492 4.009-5.566s-1.795-5.566-4.008-5.566c-2.214 0-4.008 2.492-4.008 5.566s1.794 5.566 4.008 5.566Z"
          fill="url(#q)"
        />
        <path
          d="M85.99 52.7c2.214 0 4.009-2.492 4.009-5.566s-1.795-5.566-4.008-5.566c-2.214 0-4.008 2.492-4.008 5.566S83.777 52.7 85.99 52.7Z"
          fill="url(#r)"
        />
        <path
          d="M117.136 8.222c.472-1.957 3.256-1.957 3.728 0 .169.7.715 1.245 1.414 1.414 1.957.472 1.957 3.256 0 3.728a1.918 1.918 0 0 0-1.414 1.414c-.472 1.957-3.256 1.957-3.728 0a1.918 1.918 0 0 0-1.414-1.414c-1.957-.472-1.957-3.256 0-3.728a1.918 1.918 0 0 0 1.414-1.414Z"
          fill="url(#s)"
        />
        <circle cx="27" cy="52.5" r="1.687" stroke="#6C737F" strokeWidth="2.626" />
        <circle cx="132" cy="111.5" r="1.687" stroke="#6C737F" strokeWidth="2.626" />
        <path
          d="M131.327 70.946c-.333-1.306.873-2.483 2.171-2.118l2.498.702c1.298.365 1.714 1.997.749 2.939l-1.857 1.812c-.964.942-2.586.486-2.919-.82l-.642-2.515Z"
          fill="url(#t)"
        />
        <path
          d="M45.548 114.828c1.307-.331 2.482.876 2.115 2.173l-.705 2.498c-.366 1.297-2 1.711-2.94.745l-1.81-1.859c-.94-.966-.482-2.588.825-2.919l2.515-.638Z"
          fill="url(#u)"
        />
        <path
          d="M146.437 44.064a19.944 19.944 0 0 1-11.452 15.506 19.92 19.92 0 0 1-19.215-1.441l-7.666 2.613a1.278 1.278 0 0 1-1.585-1.705l3.084-7.365a19.948 19.948 0 0 1 4.581-25.733 19.924 19.924 0 0 1 17.904-3.69 19.923 19.923 0 0 1 13.376 12.47 19.947 19.947 0 0 1 .994 9.358l-.021-.013Z"
          fill="#384250"
        />
        <circle cx="65" cy="4.5" r="1.687" stroke="#6C737F" strokeWidth="2.626" />
        <path
          d="m129.498 30.878-.482 14.887h-4.305l-.482-14.887h5.269Zm-2.64 21.76c-.747 0-1.39-.266-1.927-.797a2.624 2.624 0 0 1-.796-1.928c0-.74.265-1.372.796-1.896a2.646 2.646 0 0 1 1.927-.796c.72 0 1.352.265 1.897.796.551.524.827 1.156.827 1.896 0 .503-.129.96-.387 1.373-.252.412-.584.74-.996.985a2.546 2.546 0 0 1-1.341.366Z"
          fill="#fff"
        />
        <rect fill="url(#v)" height="10" rx="5" width="26" x="49" y="82.5" />
        <rect fill="url(#w)" height="10" rx="5" width="26" x="49" y="101.5" />
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="a"
            x1="81.495"
            x2="82.738"
            y1="-12.507"
            y2="200.423"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="#9DA4AE" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="b"
            x1="34.048"
            x2="8.743"
            y1="44.036"
            y2="19.182"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#F7F7FF" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="f"
            x1="124.403"
            x2="148.813"
            y1="102.539"
            y2="118.963"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#F7F7FF" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="g"
            x1="119.226"
            x2="88.209"
            y1="106.182"
            y2="47.661"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#D2D6DB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="h"
            x1="96.09"
            x2="59.135"
            y1="107.3"
            y2="45.911"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#D2D6DB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="i"
            x1="58.858"
            x2="96.362"
            y1="100.097"
            y2="99.834"
          >
            <stop stopColor="#D2D6DB" />
            <stop offset="1" stopColor="#9DA4AE" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="j"
            x1="81.592"
            x2="69.835"
            y1="91.285"
            y2="74.881"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#D2D6DB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="k"
            x1="81.592"
            x2="69.835"
            y1="109.786"
            y2="93.382"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#D2D6DB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="l"
            x1="46.462"
            x2="44.162"
            y1="63.066"
            y2="-12.662"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#F7F7FF" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="m"
            x1="85.554"
            x2="75.24"
            y1="51.701"
            y2="-15.928"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#F7F7FF" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="n"
            x1="67.329"
            x2="104.836"
            y1="39.807"
            y2="39.543"
          >
            <stop stopColor="#D2D6DB" />
            <stop offset="1" stopColor="#9DA4AE" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="o"
            x1="78.156"
            x2="109.434"
            y1="31.763"
            y2="29.401"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#F7F7FF" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="p"
            x1="34.77"
            x2="20.971"
            y1="84.815"
            y2="58.515"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#D2D6DB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="q"
            x1="83.177"
            x2="112.267"
            y1="21.773"
            y2="29.975"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#F7F7FF" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="r"
            x1="83.177"
            x2="112.267"
            y1="42.917"
            y2="51.12"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#F7F7FF" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="s"
            x1="126.77"
            x2="112.972"
            y1="15.815"
            y2="-10.485"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#D2D6DB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="t"
            x1="137.968"
            x2="125.13"
            y1="70.523"
            y2="66.348"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#D2D6DB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="u"
            x1="45.963"
            x2="50.154"
            y1="121.469"
            y2="108.636"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#D2D6DB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="v"
            x1="71.182"
            x2="54.861"
            y1="89.461"
            y2="74.239"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#F7F7FF" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="w"
            x1="71.182"
            x2="68.226"
            y1="108.461"
            y2="93.813"
          >
            <stop stopColor="#384250" />
            <stop offset="1" stopColor="#D2D6DB" />
          </linearGradient>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="56.772"
            id="c"
            width="116.772"
            x="9.114"
            y="30.614"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_5_57341" stdDeviation="10.943" />
          </filter>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="56.772"
            id="d"
            width="76.772"
            x="91.114"
            y="30.614"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_5_57341" stdDeviation="10.943" />
          </filter>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="56.772"
            id="e"
            width="116.772"
            x="32.114"
            y="93.614"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_5_57341" stdDeviation="10.943" />
          </filter>
        </defs>
      </svg>
    </SvgIcon>
  );
}
